export class WeakMapCache {
  cache: WeakMap<object, unknown>;

  constructor() {
    this.cache = new WeakMap<object, unknown>();
  }

  get<K extends object, V>(key: K, init: (item: K) => V) {
    const cached = this.cache.get(key);

    if (cached !== undefined) {
      // We trust that cached data fits the type signature.
      return cached as V;
    }

    const value = init(key);
    this.cache.set(key, value);

    return value;
  }
}
